export default "__VITE_ASSET__DULP8vPa__"